import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { environment } from 'src/environments/environment';
import { AuthService } from '../common/auth/auth.service';
import { DestroyComponent } from '../common/destroy-component/destroy-component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent extends DestroyComponent implements OnInit {
  profile;

  administrationNavigation = false;
  configurationNavigation = false;
  assignmentArenaNavigation = false;
  providerAvailabilityNavigation = false;

  constructor(
    private authService: AuthService,
    private localStorage: LocalStorageService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.profile = this.localStorage.retrieve('profile');
    this.loadRoles(this.profile?.roleNames || []);
  }

  loadRoles(roles: string[]): void {
    if (roles) {
      if (roles.includes('IAM_ADMINISTRATOR')) {
        this.administrationNavigation = true;
        this.configurationNavigation = true;
      }
      if (roles.includes('MEDIGENCE_EXECUTIVE')) {
        this.assignmentArenaNavigation = true;
        this.providerAvailabilityNavigation = true;
      }
    }
  }

  exit(): void {
    this.localStorage.clear();
    window.location.href = environment.loginUrl;
  }
}
